import { createContext } from 'react';

export interface ProfileModalContextType {
  isOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export const ProfileModalContext = createContext<ProfileModalContextType | undefined>(undefined);